const country_code = [

    {
        value: "1264",
        title: "Anguilla (1264)"
    },
    {
        value: "1268",
        title: "Antigua  (1268)"
    },
    {
        value: "297",
        title: "Aruba (297)"
    },
    {
        value: "1284",
        title: "BVI (1284)"
    },
    {
        value: "1246",
        title: "Barbados (1246)"
    },
    {
        value: "1441",
        title: "Bermuda (1441)"
    },
    {
        value: "599",
        title: "Bonaire (599)"
    },
    {
        value: "1345",
        title: "Cayman (1345)"
    },
    {
        value: "5999",
        title: "Curacao (5999)"
    },
    {
        value: "1767",
        title: "Dominica (1767)"
    },
    {
        value: "503",
        title: "El Salvador (503)"
    },
    {
        value: "594",
        title: "FWI-French Guiana (594)"
    },
    {
        value: "590",
        title: "FWI-Guadeloupe (590)"
    },
    {
        value: "596",
        title: "FWI-Martinique (596)"
    },
    {
        value: "679",
        title: "Fiji (679)"
    },
    {
        value: "1473",
        title: "Grenada (1473)"
    },
    {
        value: "592",
        title: "Guyana (592)"
    },
    {
        value: "509",
        title: "Haiti (509)"
    },
    {
        value: "504",
        title: "Honduras (504)"
    },
    {
        value: "1876",
        title: "Jamaica (1876)"
    },
    {
        value: "674",
        title: "Nauru (674)"
    },
    {
        value: "675",
        title: "PNG (675)"
    },
    {
        value: "507",
        title: "Panama (507)"
    },
    {
        value: "685",
        title: "Samoa (685)"
    },
    {
        value: "1869",
        title: "St. Kitts (1869)"
    },
    {
        value: "1758",
        title: "St. Lucia (1758)"
    },
    {
        value: "1784",
        title: "St. Vincent (1784)"
    },
    {
        value: "597",
        title: "Suriname (597)"
    },
    {
        value: "676",
        title: "Tonga (676)"
    },
    {
        value: "1868",
        title: "Trinidad (1868)"
    },
    {
        value: "1649",
        title: "Turks + Caicos (1649)"
    },
    {
        value: "678",
        title: "Vanuatu (678)"
    }
];

export default country_code;